import { FC } from 'react';
import { useTranslation } from '@app/app/i18n';
import { analytics } from '@app/app/analytics';
import { PlatformName } from '@app/app/analytics/types';

import { Button } from '@app/shared/ui/button';

import {
  cvaRoot,
  cvaInfoContainer,
  cvaInfoTitle,
  cvaInfoDescription,
  cvaImage,
} from './pricing-banner-styles';

type PricingBannerProps = {
  isProPlan: boolean;
  onUpgrade?: () => void;
};

export const PricingBanner: FC<PricingBannerProps> = (props) => {
  const { isProPlan, onUpgrade } = props;
  const { t } = useTranslation('pricing-banner');

  return (
    <div className={cvaRoot()}>
      <div className={cvaInfoContainer()}>
        <h4 className={cvaInfoTitle()}>
          {!isProPlan ? (
            <span dangerouslySetInnerHTML={{ __html: t('free.title') }} />
          ) : (
            <span dangerouslySetInnerHTML={{ __html: t('pro.title') }} />
          )}
        </h4>
        <p className={cvaInfoDescription()}>
          {!isProPlan ? t('free.description') : t('pro.description')}
        </p>

        {!isProPlan && onUpgrade !== undefined ? (
          <Button
            variant="blue"
            borderRadius="4xl"
            size="xLargeRaleway"
            onClick={() => {
              analytics.emitEvent('click_upgrade_to_pro', {
                [PlatformName.GTM]: {},
              });
              onUpgrade();
            }}
            isFullWidth
            className="xs:max-w-max"
          >
            {t('free.button')}
          </Button>
        ) : (
          <>
            <br />
            <p className={cvaInfoDescription()}>{t('pro.comingSoon')}</p>
          </>
        )}
      </div>

      <img
        src="/static/i/pricing_page/pricing-banner.svg"
        alt=""
        role="presentation"
        aria-hidden="true"
        className={cvaImage()}
      />
    </div>
  );
};
